import { jsxs as I, jsx as m } from "react/jsx-runtime";
import { forwardRef as S } from "react";
import { UnstyledButton as w } from "../UnstyledButton/UnstyledButton.js";
import { chipInteractiveVariants as p } from "./ChipInteractive.variants.js";
const c = p.definition().defaultVariants, f = p, k = S(
  ({
    appearance: n = c.appearance,
    className: h,
    children: y,
    enableGroupHover: o = !1,
    iconEnd: a,
    iconStart: e,
    isDisabled: t = !1,
    isDisabledFocusable: s = !1,
    size: i = c.size,
    variant: r = c.variant,
    ...d
  }, x) => {
    const N = f.root({
      appearance: n,
      className: h,
      enableGroupHover: o,
      isDisabled: t || s,
      size: i,
      variant: r
    }), V = f.icon({
      appearance: n,
      enableGroupHover: o,
      isDisabled: t || s,
      variant: r
    }), j = f.label({
      appearance: n,
      enableGroupHover: o,
      isDisabled: t || s,
      size: i,
      variant: r
    }), l = (C) => /* @__PURE__ */ m("span", { className: V, children: C });
    return /* @__PURE__ */ I(
      w,
      {
        className: N,
        isDisabled: t,
        isDisabledFocusable: s,
        ref: x,
        ...d,
        children: [
          e && l(e),
          /* @__PURE__ */ m("span", { className: j, children: y }),
          a && l(a)
        ]
      }
    );
  }
);
export {
  k as ChipInteractive
};
